import { render, staticRenderFns } from "./NavbarUserDropdown.vue?vue&type=template&id=2f65ae6a&scoped=true"
import script from "./NavbarUserDropdown.vue?vue&type=script&lang=js"
export * from "./NavbarUserDropdown.vue?vue&type=script&lang=js"
import style0 from "./NavbarUserDropdown.vue?vue&type=style&index=0&id=2f65ae6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f65ae6a",
  null
  
)

export default component.exports